import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAdmin } from '../../contexts/AdminContext';
import PageLoading from './PageLoading';

/**
 * 权限路由保护组件
 * 
 * @param {Object} props
 * @param {string[]} props.requiredPermissions 需要的权限数组
 * @param {React.ReactNode} props.children 子组件
 */
const PermissionRoute = ({ requiredPermissions, children }) => {
  const { admin, loading, hasAnyPermission } = useAdmin();

  // 加载中显示加载态
  if (loading) {
    return <PageLoading />;
  }

  // 未登录跳转登录页
  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  // 无权限显示 403 结果页
  if (requiredPermissions && requiredPermissions.length > 0 && !hasAnyPermission(requiredPermissions)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有权限访问此页面。"
        extra={
          <Button type="primary" onClick={() => window.location.href = '/'}>
            {'返回首页'}
          </Button>
        }
      />
    );
  }

  return children;
};

export default PermissionRoute;
